import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IPlacementTest } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { AddPlacementVocabularyQuestionComponent } from '../add-placement-vocabulary-question/add-placement-vocabulary-question.component';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';
import { AddPlacementAnswerComponent } from '../add-placement-answer/add-placement-answer.component';
import { ADAPTIVE_PLACEMENT_TEST } from 'src/app/dummy/testing';

@Component({
  selector: 'app-placement-vocabulary',
  templateUrl: './placement-vocabulary.component.html',
  styleUrls: ['./placement-vocabulary.component.scss']
})
export class PlacementVocabularyComponent implements OnInit {
  tabs = [{ path: '/testing-center/placement-test/vocabulary/vocabulary_pi', label: 'Vocabulary PI' },];
  TITLE = "Placement Test"
  SUB_TITLE = "Vocabulary"
  SKILL_KEY = 'vocabulary'
  TYPE_KEY: any;
  SKILL_OBJ:any;

  ITEM: any;
  QUESTION_KEY: any;

  QUESTION_LIST: any[];
  form: FormGroup;
  name: AbstractControl;
  grammar: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: PlacementTest
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }

  goBack() {
    this.router.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi`])
  }

  goBackToActivityType() {
    this.router.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi`])
  }

  goBackToActivity() {
    this.router.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi`])
  }
  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
    })
    this.route.params.subscribe(async params => {
      const { id, key } = params;
      this.QUESTION_KEY = key;
      this.TYPE_KEY = id
      const tabName = ADAPTIVE_PLACEMENT_TEST[`${id}`.toUpperCase()]
      this.SKILL_OBJ = tabName;
      this.tabs = [{ path: `/testing-center/placement-test/${this.SKILL_KEY}/${this.TYPE_KEY}`, label: tabName.name },];
      if (key !== 'draft') {
        this.store.fetchQuestion(this.QUESTION_KEY, this.TYPE_KEY, this.SKILL_KEY, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.QUESTION_LIST = [];
            this.goBack()
            return;
          }
          const { tip, questions } = doc;
          this.form.patchValue({ name: tip })
          this.QUESTION_LIST = questions;
        })
      }
    })
  }

  onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { name } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IPlacementTest = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        tip: name || null,
        questions: this.ITEM ? this.ITEM.questions : [],
        skillKey: 'vocabulary',
        testingTypeKey: this.TYPE_KEY
      }
      this.store.addItem(activity, (success, res) => {
        if (success) {
          this.snackBar.open("Question has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.location.back()
          }
          else {
            this.router.navigate([`/testing-center/placement-test/vocabulary/vocabulary_pi/${activity.key}`])
          }
          this.form.enable();
        }
      })
    }
  }


  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Question' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { name } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;

        const QUESTION_DATA = removeObjArray(questions, question.key)
        const registerStatus = STATUS_OBJECT.submitted;

        const activity: IPlacementTest = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          tip: name || null,
          questions: QUESTION_DATA,
          skillKey: 'vocabulary',
          testingTypeKey: this.TYPE_KEY
        }
        this.store.addItem(activity, (success, res) => {
          this.snackBar.open("Question has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  createQuiz(item, question) {
    let dialogRef = this.dialog.open(AddPlacementAnswerComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        QUESTION: item,
        ANSWER: question || null,
        SKILL_KEY: this.SKILL_KEY,
        TYPE_KEY: this.TYPE_KEY,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});

  }

  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddPlacementVocabularyQuestionComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        QUESTION: item || null,
        TYPE_KEY: this.TYPE_KEY,
        QUESTION_KEY: this.QUESTION_KEY,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});
  }

}
